<template>
    <div class="reminder-alerts-container" v-if="hasSlaReminders">
        <div class="reminder-alerts-container-inner w-100">
            <b-alert variant="warning" :show="hasSlaReminders" class="w-100">
                <b>{{ trans('sla.you_have_sla_reminders') }}</b>
            </b-alert>
        </div>
    </div>
</template>

<script>

    import SlaReminderController from '@/services/Notification/SlaReminderController';

    export default {

        data() {
            return {
                hasSlaReminders: false,
                reloadTimer: null
            };
        },

        created() {
            this.loadNotifications();

            const self = this;

            // check every minute
            this.reloadTimer = setInterval(function () {
                self.loadNotifications();
            }, 60000);
        },

        mounted() {
            this.$bus.$on('header.notifications.refresh', this.loadNotifications);
        },

        methods: {

            loadNotifications() {
                SlaReminderController.indexOnSite().then(response => {
                    this.hasSlaReminders = response.data.length > 0;
                });
            }
        },

        beforeDestroy: function () {
            clearInterval(this.reloadTimer);
        }

    };
</script>



// WEBPACK FOOTER //
// src/components/Alerts/SlaReminders.vue